import React, { useEffect } from "react";
import {
  Flex,
  Heading,
  Text,
  Stack,
  IconButton,
  Avatar,
} from "@chakra-ui/react"; // Add these imports
import { FaArrowLeftLong, FaXmark } from "react-icons/fa6";
import {
  textSecondary,
  newBorder,
  white,
  primaryAlt,
  color8,
} from "../../../../../utils/colors";
import MoreButton from "../../../../../components/buttons/MoreButton";
import { useTranslation } from "react-i18next";
import useIsMobile from "../../../../../hooks/useIsMobile";
import StatusButtonNew from "../../../../../components/buttons/StatusButtonNew";
import { useNavigate } from "react-router-dom";
import useThemeColors from "../../../../../hooks/useThemeColors";
import { useSelector } from "react-redux";
import ToastComponent from "../../../../../components/partials/ToastComponent";
import MoreButtonLite from "../../../../../components/buttons/MoreButtonLite";

const EmployeeHeader = ({
  slug,
  employee,
  isDoctor,
  openEdit,
  setShowDeleteConfirmation,
  setEmployeeName,
  setShowStatusUpdateConfirmation,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const toastComponent = ToastComponent();

  // COLORS
  const { whiteMode, backgroundLightMode, textPrimaryMode, newBorderMode } =
    useThemeColors();

  // HANDLERS
  const navigateBackHandler = () => {
    // window.history.back();
    navigate(`/${slug}/employees`);
  };

  // REDUX
  const userDelete = useSelector((state) => state.userDelete);
  const { success: successDelete, error: errorDelete } = userDelete;

  // USE EFFECT
  useEffect(() => {
    if (successDelete) {
      navigate("/employees");
    } else if (errorDelete) {
      toastComponent.showToast(t("toasts.employeeDeleteError"), "error", 3000);
    }
  }, [successDelete, errorDelete]);

  return (
    <>
      <Flex
        align="center"
        justify="space-between"
        p={["1.75rem 1.5rem", "1.75rem 2rem", "1.75rem 2rem"]}
        borderBottom={`1px solid ${newBorderMode}`}
        position="relative"
        width="100%"
        // bg={white}
        // zIndex="1000"
      >
        <Flex align="center">
          {!isMobile && (
            <IconButton
              bg={backgroundLightMode}
              border={`1px solid ${backgroundLightMode}`}
              color={textSecondary}
              icon={<FaArrowLeftLong />}
              borderRadius="10.75rem"
              fontSize="0.875rem"
              onClick={navigateBackHandler}
              _hover={{ bg: primaryAlt, color: white, border: primaryAlt }}
            />
          )}

          <Flex align="center" m={["0 0 0 0rem", "0 0 0 1rem", "0 0 0 1rem"]}>
            <Avatar
              h="2.75rem"
              w="2.75rem"
              bg={color8}
              color={whiteMode}
              src={employee.image}
              // borderRadius="0.75rem"
              name={`${employee.lastName} + ${employee.firstName}`}
            />

            <Stack gap={2}>
              <Heading
                ml={2}
                color={textPrimaryMode}
                fontSize="1.125rem"
                fontWeight="600"
                lineHeight="1"
              >
                {employee.lastName} {employee.firstName}
              </Heading>
              <Flex align="center">
                {employee &&
                  employee.profession &&
                  employee.profession.name && (
                    <Text
                      ml={2}
                      color={textSecondary}
                      fontSize="sm"
                      lineHeight="1"
                    >
                      {employee.profession.name}
                      <Text as="span" fontWeight="200" mx={2}>
                        |
                      </Text>
                    </Text>
                  )}

                <Text
                  ml={
                    employee && employee.profession && employee.profession.name
                      ? 0
                      : 2
                  }
                  color={textSecondary}
                  fontSize="sm"
                  lineHeight="1"
                >
                  {t("employee.headerCardNumber")}:
                  <Text as="span" fontWeight="600" ml={1} lineHeight="1">
                    {employee &&
                      employee.userID &&
                      employee.userID.length > 0 &&
                      employee.userID}
                  </Text>
                </Text>
              </Flex>
            </Stack>
          </Flex>
        </Flex>

        <Flex align="center">
          <StatusButtonNew
            currentStatus={employee.status}
            options="employee"
            onUpdateStatus={() => {
              setShowStatusUpdateConfirmation(true);
            }}
          />

          <MoreButtonLite
            id={employee._id}
            deleteHandler={true}
            setShowDeleteConfirmation={() => {
              setShowDeleteConfirmation(true); // Open confirmation modal
              setEmployeeName(`${employee.lastName} ${employee.firstName}`);
            }}
            editHandler={openEdit}
            editLabel={t("employee.editEmployee")}
            editButtonDisabled={isDoctor}
          />
        </Flex>
      </Flex>
    </>
  );
};

export default EmployeeHeader;
